var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "menu-type__wrapper",
      style:
        "display: flex;overflow-x: auto;background-color: " + _vm.restColor,
    },
    [
      _c("content-container", [
        _c(
          "ul",
          { staticClass: "menu-type__menus" },
          _vm._l(_vm.menuTypesObject, function (menu) {
            return _c(
              "li",
              {
                key: menu.label,
                staticClass: "menu-type__filter",
                class: { active: menu.isActive },
              },
              [
                _c(
                  "button",
                  {
                    class: [{ active: menu.isActive }, "menu-type__item"],
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(menu)
                      },
                    },
                  },
                  [_vm._v("\n\t\t\t\t\t" + _vm._s(menu.label) + "\n\t\t\t\t")]
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }